import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ServiceLineWorkersQueryCgResponse,
  ServiceLineWorkersQueryVariables,
} from '@common/graphql';

export type ServiceLineWorkerType = NonNullable<
  ServiceLineWorkersQueryCgResponse['serviceLineWorkers']
>[number];

export type ServiceLineWorkerTermType = ServiceLineWorkerType['terms'][number];

// Roster for the Service Line Team Review page: every worker homed to a unit in the
// service line, each with its full effective-dated term history. `schedulingPeriodId` is
// optional and only drives `fteHours` (40 × FTE% × period weeks) — absent ⇒ fteHours null.
export const SERVICE_LINE_WORKERS_QUERY: TypedDocumentNode<
  ServiceLineWorkersQueryCgResponse,
  ServiceLineWorkersQueryVariables
> = gql`
  query ServiceLineWorkers($serviceLineId: ID!, $schedulingPeriodId: ID) {
    serviceLineWorkers(
      serviceLineId: $serviceLineId
      schedulingPeriodId: $schedulingPeriodId
    ) {
      id
      name
      terms {
        id
        active
        effectiveStartDate
        effectiveEndDate
        employmentType
        role
        homeUnit
        homeUnitId
        fteHours
        preferredTime
        shiftPatternPreference
        chargeEligible
      }
    }
  }
`;
